export default class Offices {
    constructor() {
        const toggleBtn = document.querySelector('#toggleViewBtn');
        const listContainer = document.querySelector('#listContainer');
        const mapContainer = document.querySelector('#map-container');
        const toggleButtonText = document.querySelector('#toggleButtonText');

        if (!toggleBtn || !listContainer || !mapContainer || !toggleButtonText) {
            return;
        }

        mapContainer.style.display = 'none';
        listContainer.style.display = 'flex';

        toggleBtn.addEventListener('click', () => {
            if (mapContainer.style.display === 'none') {
                mapContainer.style.display = 'block';
                listContainer.style.display = 'none';
                toggleButtonText.textContent = 'Toon lijst';
                this.initMap();
            } else {
                mapContainer.style.display = 'none';
                listContainer.style.display = 'flex';
                toggleButtonText.textContent = 'Toon op kaart';
            }
        });
    }

    initMap() {
        if (this.map) return;

        let officesData = window.officesData || [];

        this.map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: 52.1326, lng: 5.2913 },
            zoom: 8,
            disableDefaultUI: true
        });

        const infoWindow = new google.maps.InfoWindow();

        officesData.forEach((office) => {
            if (office.latitude && office.longitude) {
                const marker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(office.latitude),
                        lng: parseFloat(office.longitude)
                    },
                    map: this.map,
                    icon: '/img/map-marker.svg',
                    title: office.name
                });

                marker.addListener('click', () => {
                    const contentString = `
                        <div style="max-width:300px;">
                            <h4>${office.name}</h4>
                            <p>
                                ${office.street} ${office.housenumber}<br>
                                ${office.zipcode} ${office.city}<br><br>
                                ${office.email}<br>
                                ${office.phone}
                            </p>
                        </div>
                    `;

                    infoWindow.setContent(contentString);
                    infoWindow.open(this.map, marker);
                });
            }
        });
    }
}
